import {updatePointsInHeader} from "../points/updatePointsInHeader";
import {checkForRewards} from "../rewards/checkForRewards";
import {displaySurveyResult} from "./displaySurveyResult";
export function sendSurvey(surveyId, timelineId, checkedIds) {
    if (checkedIds.length === 0) {
        checkedIds = "leer";
    }
    $.ajax({
        type: "POST",
        url: "/module/community/ajax.php?action=send_survey",
        datatype: "json",
        data: {
            "ajax_call_survey_id": surveyId,
            "ajax_call_timeline_id": timelineId,
            "ajax_call_checked_ids": checkedIds,
            "ajax_call_shop_code": shopCode,
            "ajax_call_language_code": languageCode,
            "ajax_call_list_community_type": communityType,
            "ajax_call_sid": sid
        },
        success: function (output) {
            var data = $.parseJSON(output);
            var successModal = data.success_modal;
            if ($('#survey_answer_modal_' + successModal.id).length) {
                $('#survey_answer_modal_' + successModal.id).remove();
            }
            $("body").append(successModal.modal);
            if (successModal.change_button === "true") {
                if (communityType === 1) {
                    $.each(data.timeline_elements, function (timelineKey, timelineValue) {
                        var surveyData = data.survey_answers[successModal.id];
                        displaySurveyResult($("#" + timelineValue.id), surveyData, surveyData["posted_answers"]);
                    });
                } else {
                    $.each(data.survey_answers, function (surveyId, answerValue) {
                        var surveyData = data.survey_answers[successModal.id];
                        displaySurveyResult($("#" + surveyId), surveyData, surveyData["posted_answers"]);
                    });
                }
            }
            $('#survey_answer_modal_' + successModal.id).modal("show");
            updatePointsInHeader();
            checkForRewards(3); // Check for rewards of type survey
        }
    });
}